<template>
  <div id="app">
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">Masraf Merkezi Mizanı</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html İndir</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel İndir</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>



            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-layout row wrap>


              <v-flex xs12 sm6 md4 style="padding-right:2px;padding-bottom:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">cached</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Borç Toplamı
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ toplamCariBorc }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Alacak Toplamı
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ toplamCariAlacak }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold">Cari Borç/Alacak</span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>


              <v-flex xs12 sm6 md4 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">layers</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Borç Toplamı
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ toplamGenelBorc }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Alacak Toplamı
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ toplamGenelAlacak }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold">Genel Toplam </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>

               <v-flex xs12 sm6 md4 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">business_center</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">

                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                   {{ toplamBakiye | bakiyekontrol }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">

                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">

                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold">Genel Bakiye</span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>



            </v-layout>
          </v-container>

          <v-container fluid>



            <v-card color="grey lighten-5" flat>
                                          <v-form ref="formtarih" v-model="valid" lazy-validation>

              <v-layout row wrap>

                <v-flex xs12 sm6 md2>
                                     <tarihcomp :etiket="'Başlangıç Tarihi'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                      v-bind:defaultvalue="'ok'" v-bind:value="date" v-model="date"></tarihcomp>


                </v-flex>
                <v-flex xs12 sm6 md2>
                            <tarihcomp :etiket="'Bitiş Tarihi'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                      v-bind:defaultvalue="'ok'" v-bind:value="date2" v-model="date2"></tarihcomp>
                </v-flex>


                <v-flex>
                  <v-layout>
                    <div v-if="load1">
                      <v-btn color="info" @click="getList()" fab small="" dark>
                        <v-icon>search</v-icon>
                      </v-btn>
                    </div>
                    <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                      color="info" fab dark>
                      <v-icon>filter_list</v-icon>
                    </v-btn>
                    <v-tooltip bottom="" :activator="el" v-model="tooltip">
                      <span>Arama Filtresi Ekle</span>
                    </v-tooltip>
                  </v-layout>
                </v-flex>







                <v-dialog v-model="dialogfiltre" persistent="" max-width="410px">
                  <v-card color="grey lighten-2">
                    <v-card-title>Filtre Seçimi</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-flex xs12 sm12 md12>
                <v-layout justify-space-between column>
                        <v-select :items="masrafmerkezi" hide-details="" label="İlk Masraf" item-text="CodeName" v-model="MizanMasraf.BaslangicMasraf.Code"
                          clearable item-value="Code" max-height="400"></v-select>
                        <v-select :items="masrafmerkezi" hide-details="" label="Son Masraf" item-text="CodeName" v-model="MizanMasraf.BitisMasraf.Code"
                          clearable item-value="Code" max-height="400" persistent-hint></v-select>
                        <v-checkbox hide-details="" v-model="tumsirketler" label="Tüm Şirketler"></v-checkbox>
                </v-layout>
                        </v-flex>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="filtreiptal()">İptal</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Fİltrelerİ Uygula</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                   <v-flex xs12 sm12 md12>

                  <v-card>

                    <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
                      :search="search3">
                      <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                      <template slot="items" slot-scope="props">
                        <tr @click="git(props.item.Account+'-'+props.item.Date+'-'+ props.item.Id)" item>
                          <td class="text-xs-left">{{ props.item.Code }}</td>
                          <td class="text-xs-left">{{ props.item.CodeName }}</td>
                          <td class="text-xs-right">{{ props.item.CariBorc | moneyformat}}</td>
                          <td class="text-xs-right">{{ props.item.CariAlacak | moneyformat}}</td>
                          <td class="text-xs-right">{{ props.item.GenelBorc | moneyformat}}</td>
                          <td class="text-xs-right">{{ props.item.GenelAlacak | moneyformat }}</td>
                          <td class="text-xs-right">{{ props.item.GenelBakiye | bakiyekontrol }}</td>

                        </tr>
                      </template>
                      <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                      </v-alert>
                    </v-data-table>
                  </v-card>

                  <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                    :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                    {{ text1 }}
                    <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
                  </v-snackbar>
                </v-flex>
              </v-layout>
                                          </v-form>
            </v-card>
          </v-container>

        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from "../../../api/auth";
  import helpers from "@/components/app/customcomp/helpers.js"
  import tarihcomp from '../customcomp/tarihim'

  export default {
    data() {
      return {
        valid:true,
        search: "",
        headers: [{
            text: " Masraf Merkezi",
            value: "Code"
          },
          {
            text: "Masraf Merkezi Adı",
            value: "CodeName"
          },
          {
            text: "Cari Borç",
            value: "CariBorc",
            align:  'right'

          },
          {
            text: "Cari Alacak",
            value: "CariAlacak",
            align:  'right'

          },
          {
            text: "Genel Borç",
            value: "GenelBorc",
            align:  'right'

          },
          {
            text: "Genel Alacak",
            value: "GenelAlacak",
            align:  'right'

          },
          {
            text: "Genel Bakiye",
            value: "GenelBakiye",
            align:  'right'

          }
        ],
        MizanMasraf: {

          SirketKodu: '',
          BaslangicMasraf: {
            Code: ''
          },
          BitisMasraf: {
            Code: ''
          },
          BaslangicTarih: '',
          BitisTarih: '',
          Cari: {
            Kod: ''
          },

          CariAlacak: "",
          CariBorc: "",
          CariKod: "",
          CariUnvan: "",
          GenelAlacak: "",
          GenelBakiye: "",
          GenelBorc: ""
        },
        toplamBakiye: 0,
        toplamCariAlacak: 0,
        toplamCariBorc: 0,
        toplamGenelAlacak: 0,
        toplamGenelBorc: 0,
        toplamRisk: 0,
        StartDate: null,
        EndDate: null,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        progress: false,
        items: [],
        load: false,
        load1: true,
        search3: '',
        renk1: 'info',
        dialogfiltre: false,
        tumsirketler: false,
        hesapkodu: [],
        anahesap: [],
        masrafmerkezi: [],
        butondurum: true,
        snackbar: false,
        y: "top",
        x: "right",
        mode: "",
        timeout: 6000,
        text1: "",
        tooltip: false,
        el: null,
        dictionary: {
          custom: {

            tarihsec: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
            tarihsec1: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
          }
        },
      };
    },
    beforeMount: beforeMount,
      components: {
      tarihcomp
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

    },
       filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },
    methods: {

      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal
    }
  }

  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })

  }

  function filtrekayit() {
    this.renk1 = 'orange darken-4'
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.renk1 = 'info'
    this.MizanMasraf.BaslangicMasraf = '',
      this.MizanMasraf.BitisMasraf = '',
      this.tumsirketler = false,
      this.dialogfiltre = false


  }


  function getList() {

      if (this.$refs.formtarih.validate()) {


        var bastarih = new Date(this.date)
        var bittarih = new Date(this.date2)

        if (bastarih <= bittarih) {

          this.toplamBakiye = 0;
          this.toplamCariAlacak = 0;
          this.toplamCariBorc = 0;
          this.toplamGenelAlacak = 0;
          this.toplamGenelBorc = 0;

          this.progress = true
          this.load1 = false;


          var credentials = JSON.parse(window.localStorage.getItem('credentials'));

          this.MizanMasraf.BaslangicTarih = this.date
          this.MizanMasraf.BitisTarih = this.date2

          if (this.tumsirketler === true) {
            this.MizanMasraf.SirketKodu = '0'
          } else {
            this.MizanMasraf.SirketKodu = credentials.SirketKodu
          }

          var params = this.MizanMasraf

          this.$http
            .post(auth.API_URL + "api/TrialBalance/WithExpenseCenter", params, {
              headers: {
                Authorization: "Bearer " + auth.getAuthHeader()
              }
            })
            .then(
              response => {
                this.items = response.body.List;
                this.toplamBakiye = response.body.ToplamBakiye
                this.toplamCariAlacak = response.body.ToplamCariAlacak.toFixed(
                  2
                ).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
                this.toplamCariBorc = response.body.ToplamCariBorc.toFixed(2).replace(
                  /(\d)(?=(\d{3})+\.)/g,
                  "$1,"
                );
                this.toplamGenelAlacak = response.body.ToplamGenelAlacak.toFixed(
                  2
                ).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
                this.toplamGenelBorc = response.body.ToplamGenelBorc.toFixed(2).replace(
                  /(\d)(?=(\d{3})+\.)/g,
                  "$1,"
                );

                this.progress = false
                this.load1 = true;
              },
              response => {
                if (response.status === 0) {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                  this.progress = false
                  this.load1 = true;
                } else {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                  this.progress = false
                  this.load1 = true;
                }
              }
            );

        } else {
          this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
          this.snackbar = true
        }
      }


  }


  function getListHtml() {

    this.toplamBakiye = 0;
    this.toplamCariAlacak = 0;
    this.toplamCariBorc = 0;
    this.toplamGenelAlacak = 0;
    this.toplamGenelBorc = 0;

    this.progress = true
    this.load1 = false;


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.MizanMasraf.BaslangicTarih = this.date
    this.MizanMasraf.BitisTarih = this.date2

    if (this.tumsirketler === true) {
      this.MizanMasraf.SirketKodu = '0'
    } else {
      this.MizanMasraf.SirketKodu = credentials.SirketKodu
    }

    var params = this.MizanMasraf

    this.$http
      .post(auth.API_URL + "api/TrialBalance/WithExpenseCenterHtmlReport", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        }
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/html'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "MizanMasraf.html";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text = "Service Unavailable";
          this.snackbar = true;
          this.progress = false
          this.load1 = true;
        } else {
          this.text = "Service Unavailable";
          this.snackbar = true;
          this.progress = false
          this.load1 = true;
        }
      });
  }

  function getListExcel() {

    this.toplamBakiye = 0;
    this.toplamCariAlacak = 0;
    this.toplamCariBorc = 0;
    this.toplamGenelAlacak = 0;
    this.toplamGenelBorc = 0;

    this.progress = true
    this.load1 = false;


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.MizanMasraf.BaslangicTarih = this.date
    this.MizanMasraf.BitisTarih = this.date2

    if (this.tumsirketler === true) {
      this.MizanMasraf.SirketKodu = '0'
    } else {
      this.MizanMasraf.SirketKodu = credentials.SirketKodu
    }

    var params = this.MizanMasraf

    this.$http
      .post(auth.API_URL + "api/TrialBalance/WithExpenseCenterExcelReport", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        },responseType: "arraybuffer"
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/xlsx'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "MizanMasraf.xlsx";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text = "Service Unavailable";
          this.snackbar = true;
          this.progress = false
          this.load1 = true;
        } else {
          this.text = "Service Unavailable";
          this.snackbar = true;
          this.progress = false
          this.load1 = true;
        }
      });
  }


  function beforeMount() {
    this.toplamBakiye = 0;
    this.toplamCariAlacak = 0;
    this.toplamCariBorc = 0;
    this.toplamGenelAlacak = 0;
    this.toplamGenelBorc = 0;
    this.toplamRisk = 0;

    this.load = true;
    this.load1 = false;
    this.date = helpers.getDateNow()
    this.date2 = helpers.getDateNow()

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      BaslangicTarih: this.date,
      BitisTarih: this.date2,
      SirketKodu: credentials.SirketKodu
    };

    this.$http
      .post(auth.API_URL + "api/TrialBalance/WithExpenseCenter", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        }
      })
      .then(
        response => {
          this.items = response.body.List;
          this.toplamBakiye = response.body.ToplamBakiye

          this.toplamCariAlacak = response.body.ToplamCariAlacak.toFixed(
            2
          ).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
          this.toplamCariBorc = response.body.ToplamCariBorc.toFixed(2).replace(
            /(\d)(?=(\d{3})+\.)/g,
            "$1,"
          );
          this.toplamGenelAlacak = response.body.ToplamGenelAlacak.toFixed(
            2
          ).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
          this.toplamGenelBorc = response.body.ToplamGenelBorc.toFixed(2).replace(
            /(\d)(?=(\d{3})+\.)/g,
            "$1,"
          );
          this.toplamRisk = response.body.ToplamRisk.toFixed(2).replace(
            /(\d)(?=(\d{3})+\.)/g,
            "$1,"
          );

          this.load = false;
          this.load1 = true;
        },
        response => {
          if (response.status === 0) {
            this.text = "Service Unavailable";
            this.snackbar = true;
            this.load = false;
            this.load1 = true;
          } else {
            this.text = "Service Unavailable";
            this.snackbar = true;
            this.load = false;
            this.load1 = true;
          }
        }
      );
  }

</script>
<style>
</style>